import confetti from 'canvas-confetti'
import React from 'react'

export default function Complete({ children }) {
    const canvasRef = React.useRef(null)

    React.useEffect(() => {
        if (canvasRef.current) {
            const myConfetti = confetti.create(canvasRef.current, { resize: true })

            myConfetti({
                particleCount: 100,
                spread: 70,
                origin: { x: 0.5, y: 1 },
            })
        }
    }, [])

    return <div className="flex items-center flex-col gap-2 justify-center h-full relative w-full">
        <canvas
            ref={canvasRef}
            className="absolute top-0 left-0 w-full h-full pointer-events-none"
        />

        <dotlottie-player src="/kQSRkKKCwq.lottie" background="transparent" speed="1" style={{ width: 300, height: 300 }} autoplay></dotlottie-player>

        <span className="relative bottom-6 select-none font-semibold">Commande complétée</span>
        {children}
    </div>
}